"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SecurityMonitoringRuleNewValueOptions = void 0;
/**
 * Options on new value rules.
 */
class SecurityMonitoringRuleNewValueOptions {
    constructor() { }
    /**
     * @ignore
     */
    static getAttributeTypeMap() {
        return SecurityMonitoringRuleNewValueOptions.attributeTypeMap;
    }
}
exports.SecurityMonitoringRuleNewValueOptions = SecurityMonitoringRuleNewValueOptions;
/**
 * @ignore
 */
SecurityMonitoringRuleNewValueOptions.attributeTypeMap = {
    forgetAfter: {
        baseName: "forgetAfter",
        type: "SecurityMonitoringRuleNewValueOptionsForgetAfter",
        format: "int32",
    },
    learningDuration: {
        baseName: "learningDuration",
        type: "SecurityMonitoringRuleNewValueOptionsLearningDuration",
        format: "int32",
    },
    learningMethod: {
        baseName: "learningMethod",
        type: "SecurityMonitoringRuleNewValueOptionsLearningMethod",
    },
    learningThreshold: {
        baseName: "learningThreshold",
        type: "SecurityMonitoringRuleNewValueOptionsLearningThreshold",
        format: "int32",
    },
    additionalProperties: {
        baseName: "additionalProperties",
        type: "any",
    },
};
//# sourceMappingURL=SecurityMonitoringRuleNewValueOptions.js.map